export default __webpack_public_path__ + "static/media/Background 5_00012.5d01a791.png";